module.exports = __webpack_public_path__ + "static/images/fields/email_field.svg";